import Swal from "sweetalert2";

const TextThemePopup = {
    general: (navigate, textThemeNavState) => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "liner-light-blue-background",
                cancelButton: "custom-btn liner-light-blue-background me-4 bold-content",
            },
            buttonsStyling: true,
        });
        swalWithBootstrapButtons.fire({
            html: "<p class='swal-text'>The consumer filters applied on this analysis page will not be carried forward to the Theme Text Analysis page</p>",
            width: 500,
            padding: 10,
            color: "#005eef",
            showConfirmButton: true,
            customClass: {
                popup: "custom-swal-popup",
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/text-theme-analysis", { state: textThemeNavState });
            }
        });
    },
};

export default TextThemePopup;
